import React from 'react'

import { DesignSystemProvider } from '../../theme/Provider'

import { Spin as SpinBase } from './Spin'
import type { SpinProps } from './types'

export const Spin: React.FC<SpinProps> = (props) => (
  <DesignSystemProvider>
    <SpinBase {...props} />
  </DesignSystemProvider>
)

export type { SpinProps, SpinSize } from './types'
